/* tslint:disable */
/* eslint-disable */
/**
 * Payment Service API
 * 통합 정리된 결제 서비스 API 명세 - 완전 React 마이그레이션  **주요 개선사항:** - 모든 Thymeleaf 페이지를 REST API로 변환 - 기능별 그룹화된 경로 구조 - 표준화된 응답 형식 - React SPA 완전 지원  **API 구조:** - 결제수단 관리: `/api/v1/payment-methods/_*` - 구독 관리: `/api/v1/subscriptions/_*`  - 플랜 관리: `/api/v1/plans/_*` - 주문 관리: `/api/v1/orders/_*` - 대시보드: `/api/v1/dashboard/_*` - NicePay 결제: `/api/v1/payment/nicepay/_*` - 세션 관리: `/api/v1/auth/_*` 
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { AmountVerifyRequest } from '../models';
// @ts-ignore
import type { AmountVerifyResponse } from '../models';
// @ts-ignore
import type { CreateOrderSession200Response } from '../models';
// @ts-ignore
import type { CreateOrderSessionRequest } from '../models';
// @ts-ignore
import type { ErrorResponse2 } from '../models';
// @ts-ignore
import type { OrderInfoResponse } from '../models';
// @ts-ignore
import type { ReceiptGenerationContext } from '../models';
// @ts-ignore
import type { ReceiptIssueResponse } from '../models';
// @ts-ignore
import type { RefundRequest } from '../models';
// @ts-ignore
import type { RefundResponse } from '../models';
/**
 * PaymentApi - axios parameter creator
 * @export
 */
export const PaymentApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 단건 결제용 주문 세션 생성
         * @param {CreateOrderSessionRequest} createOrderSessionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrderSession: async (createOrderSessionRequest: CreateOrderSessionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createOrderSessionRequest' is not null or undefined
            assertParamExists('createOrderSession', 'createOrderSessionRequest', createOrderSessionRequest)
            const localVarPath = `/api/v1/payment/create-order-session`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createOrderSessionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 주문 정보 조회
         * @param {string} orderId 주문 ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderInfo: async (orderId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('getOrderInfo', 'orderId', orderId)
            const localVarPath = `/api/v1/payment/orders/{orderId}`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 영수증 발급
         * @param {ReceiptGenerationContext} receiptGenerationContext 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        issueReceipt: async (receiptGenerationContext: ReceiptGenerationContext, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'receiptGenerationContext' is not null or undefined
            assertParamExists('issueReceipt', 'receiptGenerationContext', receiptGenerationContext)
            const localVarPath = `/api/v1/payment/receipt`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(receiptGenerationContext, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 환불 요청
         * @param {RefundRequest} refundRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestRefund: async (refundRequest: RefundRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'refundRequest' is not null or undefined
            assertParamExists('requestRefund', 'refundRequest', refundRequest)
            const localVarPath = `/api/v1/payment/refund`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(refundRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 결제 금액 검증
         * @param {AmountVerifyRequest} amountVerifyRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyAmount: async (amountVerifyRequest: AmountVerifyRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'amountVerifyRequest' is not null or undefined
            assertParamExists('verifyAmount', 'amountVerifyRequest', amountVerifyRequest)
            const localVarPath = `/api/v1/payment/verify-amount`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(amountVerifyRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PaymentApi - functional programming interface
 * @export
 */
export const PaymentApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PaymentApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 단건 결제용 주문 세션 생성
         * @param {CreateOrderSessionRequest} createOrderSessionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createOrderSession(createOrderSessionRequest: CreateOrderSessionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateOrderSession200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createOrderSession(createOrderSessionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentApi.createOrderSession']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 주문 정보 조회
         * @param {string} orderId 주문 ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrderInfo(orderId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrderInfoResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrderInfo(orderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentApi.getOrderInfo']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 영수증 발급
         * @param {ReceiptGenerationContext} receiptGenerationContext 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async issueReceipt(receiptGenerationContext: ReceiptGenerationContext, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReceiptIssueResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.issueReceipt(receiptGenerationContext, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentApi.issueReceipt']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 환불 요청
         * @param {RefundRequest} refundRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async requestRefund(refundRequest: RefundRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RefundResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.requestRefund(refundRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentApi.requestRefund']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 결제 금액 검증
         * @param {AmountVerifyRequest} amountVerifyRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async verifyAmount(amountVerifyRequest: AmountVerifyRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AmountVerifyResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.verifyAmount(amountVerifyRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentApi.verifyAmount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PaymentApi - factory interface
 * @export
 */
export const PaymentApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PaymentApiFp(configuration)
    return {
        /**
         * 
         * @summary 단건 결제용 주문 세션 생성
         * @param {PaymentApiCreateOrderSessionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrderSession(requestParameters: PaymentApiCreateOrderSessionRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateOrderSession200Response> {
            return localVarFp.createOrderSession(requestParameters.createOrderSessionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 주문 정보 조회
         * @param {PaymentApiGetOrderInfoRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderInfo(requestParameters: PaymentApiGetOrderInfoRequest, options?: RawAxiosRequestConfig): AxiosPromise<OrderInfoResponse> {
            return localVarFp.getOrderInfo(requestParameters.orderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 영수증 발급
         * @param {PaymentApiIssueReceiptRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        issueReceipt(requestParameters: PaymentApiIssueReceiptRequest, options?: RawAxiosRequestConfig): AxiosPromise<ReceiptIssueResponse> {
            return localVarFp.issueReceipt(requestParameters.receiptGenerationContext, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 환불 요청
         * @param {PaymentApiRequestRefundRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestRefund(requestParameters: PaymentApiRequestRefundRequest, options?: RawAxiosRequestConfig): AxiosPromise<RefundResponse> {
            return localVarFp.requestRefund(requestParameters.refundRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 결제 금액 검증
         * @param {PaymentApiVerifyAmountRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyAmount(requestParameters: PaymentApiVerifyAmountRequest, options?: RawAxiosRequestConfig): AxiosPromise<AmountVerifyResponse> {
            return localVarFp.verifyAmount(requestParameters.amountVerifyRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PaymentApi - interface
 * @export
 * @interface PaymentApi
 */
export interface PaymentApiInterface {
    /**
     * 
     * @summary 단건 결제용 주문 세션 생성
     * @param {PaymentApiCreateOrderSessionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentApiInterface
     */
    createOrderSession(requestParameters: PaymentApiCreateOrderSessionRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateOrderSession200Response>;

    /**
     * 
     * @summary 주문 정보 조회
     * @param {PaymentApiGetOrderInfoRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentApiInterface
     */
    getOrderInfo(requestParameters: PaymentApiGetOrderInfoRequest, options?: RawAxiosRequestConfig): AxiosPromise<OrderInfoResponse>;

    /**
     * 
     * @summary 영수증 발급
     * @param {PaymentApiIssueReceiptRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentApiInterface
     */
    issueReceipt(requestParameters: PaymentApiIssueReceiptRequest, options?: RawAxiosRequestConfig): AxiosPromise<ReceiptIssueResponse>;

    /**
     * 
     * @summary 환불 요청
     * @param {PaymentApiRequestRefundRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentApiInterface
     */
    requestRefund(requestParameters: PaymentApiRequestRefundRequest, options?: RawAxiosRequestConfig): AxiosPromise<RefundResponse>;

    /**
     * 
     * @summary 결제 금액 검증
     * @param {PaymentApiVerifyAmountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentApiInterface
     */
    verifyAmount(requestParameters: PaymentApiVerifyAmountRequest, options?: RawAxiosRequestConfig): AxiosPromise<AmountVerifyResponse>;

}

/**
 * Request parameters for createOrderSession operation in PaymentApi.
 * @export
 * @interface PaymentApiCreateOrderSessionRequest
 */
export interface PaymentApiCreateOrderSessionRequest {
    /**
     * 
     * @type {CreateOrderSessionRequest}
     * @memberof PaymentApiCreateOrderSession
     */
    readonly createOrderSessionRequest: CreateOrderSessionRequest
}

/**
 * Request parameters for getOrderInfo operation in PaymentApi.
 * @export
 * @interface PaymentApiGetOrderInfoRequest
 */
export interface PaymentApiGetOrderInfoRequest {
    /**
     * 주문 ID
     * @type {string}
     * @memberof PaymentApiGetOrderInfo
     */
    readonly orderId: string
}

/**
 * Request parameters for issueReceipt operation in PaymentApi.
 * @export
 * @interface PaymentApiIssueReceiptRequest
 */
export interface PaymentApiIssueReceiptRequest {
    /**
     * 
     * @type {ReceiptGenerationContext}
     * @memberof PaymentApiIssueReceipt
     */
    readonly receiptGenerationContext: ReceiptGenerationContext
}

/**
 * Request parameters for requestRefund operation in PaymentApi.
 * @export
 * @interface PaymentApiRequestRefundRequest
 */
export interface PaymentApiRequestRefundRequest {
    /**
     * 
     * @type {RefundRequest}
     * @memberof PaymentApiRequestRefund
     */
    readonly refundRequest: RefundRequest
}

/**
 * Request parameters for verifyAmount operation in PaymentApi.
 * @export
 * @interface PaymentApiVerifyAmountRequest
 */
export interface PaymentApiVerifyAmountRequest {
    /**
     * 
     * @type {AmountVerifyRequest}
     * @memberof PaymentApiVerifyAmount
     */
    readonly amountVerifyRequest: AmountVerifyRequest
}

/**
 * PaymentApi - object-oriented interface
 * @export
 * @class PaymentApi
 * @extends {BaseAPI}
 */
export class PaymentApi extends BaseAPI implements PaymentApiInterface {
    /**
     * 
     * @summary 단건 결제용 주문 세션 생성
     * @param {PaymentApiCreateOrderSessionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentApi
     */
    public createOrderSession(requestParameters: PaymentApiCreateOrderSessionRequest, options?: RawAxiosRequestConfig) {
        return PaymentApiFp(this.configuration).createOrderSession(requestParameters.createOrderSessionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 주문 정보 조회
     * @param {PaymentApiGetOrderInfoRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentApi
     */
    public getOrderInfo(requestParameters: PaymentApiGetOrderInfoRequest, options?: RawAxiosRequestConfig) {
        return PaymentApiFp(this.configuration).getOrderInfo(requestParameters.orderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 영수증 발급
     * @param {PaymentApiIssueReceiptRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentApi
     */
    public issueReceipt(requestParameters: PaymentApiIssueReceiptRequest, options?: RawAxiosRequestConfig) {
        return PaymentApiFp(this.configuration).issueReceipt(requestParameters.receiptGenerationContext, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 환불 요청
     * @param {PaymentApiRequestRefundRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentApi
     */
    public requestRefund(requestParameters: PaymentApiRequestRefundRequest, options?: RawAxiosRequestConfig) {
        return PaymentApiFp(this.configuration).requestRefund(requestParameters.refundRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 결제 금액 검증
     * @param {PaymentApiVerifyAmountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentApi
     */
    public verifyAmount(requestParameters: PaymentApiVerifyAmountRequest, options?: RawAxiosRequestConfig) {
        return PaymentApiFp(this.configuration).verifyAmount(requestParameters.amountVerifyRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

